import XAPPService from "app/Core/services/XAPPService";
export const GET_TAREFAAPONTAMENTO = "[TAREFAAPONTAMENTO APP] GET TAREFAAPONTAMENTO";
export const GET_TAREFAAPONTAMENTOS = "[TAREFAAPONTAMENTO APP] GET TAREFAAPONTAMENTOS";
export const GET_TAREFAAPONTAMENTOS_OPERACAO = "[TAREFAAPONTAMENTO APP] GET TAREFAAPONTAMENTOS OPERACOES";
export const GET_PEDIDO_ITENS = "[TAREFAAPONTAMENTO APP] GET PEDIDO ITENS";
export const REMOVE_TAREFAAPONTAMENTO = "[TAREFAAPONTAMENTO APP] REMOVE TAREFAAPONTAMENTO";
export const ADD_TAREFAAPONTAMENTO = "[TAREFAAPONTAMENTO APP] ADD TAREFAAPONTAMENTO";
export const TAREFAAPONTAMENTO_WARNING = "[TAREFAAPONTAMENTO APP] TAREFAAPONTAMENTO WARNING";
export const TAREFAAPONTAMENTO_INFO = "[TAREFAAPONTAMENTO APP] TAREFAAPONTAMENTO INFO";
export const TAREFAAPONTAMENTO_ERROR = "[TAREFAAPONTAMENTO APP] TAREFAAPONTAMENTO ERROR";
export const OPEN_TAREFAAPONTAMENTODIALOG = "[TAREFAAPONTAMENTO APP] OPEN TAREFAAPONTAMENTO DIALOG";
export const OPEN_NOVO_TAREFAAPONTAMENTODIALOG = "[TAREFAAPONTAMENTO APP] OPEN NOVO TAREFAAPONTAMENTO DIALOG";
export const NOVAGUIA_TAREFAAPONTAMENTO = "[TAREFAAPONTAMENTO APP] NOVA GUIA TAREFAAPONTAMENTO";
export const TOGGLE_IMPRIMIR_RECIBO = "[TAREFAAPONTAMENTO APP] TOGGLE IMPRIMIR RECIBO";
export const GET_RECIBOS = "[TAREFAAPONTAMENTO APP] GET RECIBOS";
export const GET_PEDIDOS_EM_ABERTO = "[TAREFAAPONTAMENTO APP] GET PEDIDOS EM ABERTO";

export const ApontamentoListState =
    [
        "idtarefaprocessoapontamento",
        "idtarefaprocesso",
        "idpessoaformulario",
        "parent",
        "valorpendente",
        "nome",
        "valortotal",
        "valortotaldescricao",
        "descricaocomercial",
        "observacao",
        "natureza",
        "naturezadescricao",
        "competencia",
        "competenciadescricao",
        "validade",
        "validadedescricao",
        "status",
        "statusregistro",
        "itens",
        "aprovacao",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao"
    ];

export const ApontamentoGetState =
    [
        "idtarefaprocessoapontamento",
        "idtarefaprocesso",
        "idpessoaformulario",
        "parent",
        "valorpendente",
        "nome",
        "descricaocomercial",
        "observacao",
        "valortotal",
        "natureza",
        "naturezadescricao",
        "status",
        "aprovacao",
        "aprovacaodescricao",
        "competencia",
        "competenciadescricao",
        "validade",
        "validadedescricao",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao",
        "itens"
    ];

export const ApontamentoOperacaoState =
    [
        "idtarefaprocessoapontamentooperacao",
        "idtarefaprocessoapontamento",
        "operacao",
        "operacaodata",
        "operacaousuario",
        "operacaousuariodescricao",
        "descricao",
        "usrins",
        "usrupt",
        "datainsdescricao",
        "datauptdescricao"
    ];

export function list(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "tarefaprocessoapontamento.idtarefaprocesso", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamento", AActions, "spvwtarefaprocessoapontamento", ApontamentoListState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TAREFAAPONTAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function get(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "tarefaprocessoapontamento.idtarefaprocessoapontamento", "Operador": "=", "Valor": _AID }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamento", AActions, "spvwtarefaprocessoapontamento", ApontamentoGetState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TAREFAAPONTAMENTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function getOperacao(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "tarefaprocessoapontamentooperacao.idtarefaprocessoapontamento", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamentoOperacao", AActions, "spvwtarefaprocessoapontamentooperacao", ApontamentoOperacaoState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TAREFAAPONTAMENTOS_OPERACAO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AAction, _AValue, _AParams, _AID, _AContexto) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue, "", AConditionsAND, AConditionsOR, 1, null, _AContexto);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactiontarefaprocessoapontamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: TAREFAAPONTAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: TAREFAAPONTAMENTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)));
                }
            }

            ).catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function remove(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idtarefaprocessoapontamento", "Operador": "=", "Valor": _AValue.idtarefaprocessoapontamento }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", "EXCLUIR", "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams)
            .then(() =>
                Promise.all([
                    dispatch({
                        type: REMOVE_TAREFAAPONTAMENTO
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function getTituloByPedido(_AAction, _AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "idtarefaprocessoapontamento", "Operador": "=", "Valor": _AID }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamento", AActions, "spvwgettitulobypedido", ["idtarefaprocessoapontamento"], _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    Promise.all([
                        dispatch(get(_AAction, _AParams, JSON.parse(response.data)[0].data[0].idtarefaprocessoapontamento))
                    ]);
                }
            })
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function openDialog(_AID) {
    return {
        type: OPEN_TAREFAAPONTAMENTODIALOG,
        payload: _AID
    };
}

export function openNovoDialog(_AValue) {
    return {
        type: OPEN_NOVO_TAREFAAPONTAMENTODIALOG,
        payload: _AValue
    };
}

export function gerarGuia(_AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "tarefaprocessoapontamento.idtarefaprocessoapontamento", "Operador": "=", "Valor": _AID }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamento", AActions, "spvwtarefaprocessoapontamento", ApontamentoGetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: NOVAGUIA_TAREFAAPONTAMENTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function acaoRegistroItem(_AAction, _AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idtarefaprocessoapontamentoitem", "Operador": "=", "Valor": _AValue.idtarefaprocessoapontamentoitem }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamentoitem", _AAction, _AValue, "", AConditionsAND, AConditionsOR, 1, ["validacao"]);
        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: TAREFAAPONTAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: TAREFAAPONTAMENTO_INFO,
                            payload: null
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)));
                }
            }
            ).catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function saveItem(_AAction, _AValue, _AParams, _AState) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactiontarefaprocessoapontamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: TAREFAAPONTAMENTO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(listEmAberto(_AParams, _AState)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: TAREFAAPONTAMENTO_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(listEmAberto(_AParams, _AState)));
                }
            }

            ).catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function openReciboDialog(_AID = null) {
    return {
        type: TOGGLE_IMPRIMIR_RECIBO,
        id: _AID,
    };
}

export function listRecibo(_AParams, _AID) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "tarefaprocessoapontamentorelacionamento.idparent", "Operador": "=", "Valor": _AID }];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Recibos", AActions, "spvwtarefaprocessoapontamentorecibo", ["*"], "SELECIONAR", AConditionsAND, []);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_RECIBOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}

export function listEmAberto(_AParams, _AState) {

    return (dispatch) => {

        var AConditions1 = [
            { "Campo": "tarefaprocessoapontamento.idpessoaformulario", "Operador": "=", "Valor": _AState.idpessoaformulario },
            { "Campo": "tarefaprocessoapontamento.idtarefaprocesso", "Operador": "=", "Valor": _AState.idtarefaprocesso }
        ];
        var AConditions2 = [
            { "Campo": "tarefaprocessoapontamento.idpessoaformulario", "Operador": "=", "Valor": _AState.idpessoaformulario },
            { "Campo": "tarefaprocessoapontamento.idtarefaprocesso", "Operador": "!=", "Valor": _AState.idtarefaprocesso }
        ];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamento", AActions, "spvwtarefaprocessoapontamentoemaberto", ApontamentoListState, "SELECIONAR", AConditions1, []);
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefaProcessoApontamento", AActions, "spvwtarefaprocessoapontamentoemaberto", ApontamentoListState, "SELECIONAR", AConditions2, []);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TAREFAAPONTAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_PEDIDOS_EM_ABERTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: TAREFAAPONTAMENTO_ERROR,
                    payload: error
                });
            });
    };
}